// extracted by mini-css-extract-plugin
export default {"tag":"BtzaE","middle":"YQl6r","image":"CWUMb","text":"WmCrw","withAnimation":"MxhQ5","animation":"IM5I7","text1":"dUVYi","text2":"Jqj8a"};